import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchCollection, getVal } from '../lib/api';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [contactInfo, setContactInfo] = useState(null);

  useEffect(() => {
    async function loadContact() {
      try {
        const data = await fetchCollection('kontakt_information');
        if (data.items && data.items.length > 0) {
          setContactInfo(data.items[0]);
        }
      } catch (err) {
        console.error('Kunne ikke hente kontaktinformation i Footer:', err);
      }
    }
    loadContact();
  }, []);

  return (
    <footer className="border-t border-brand-orange/10 bg-dark-graphite text-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:items-start">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.45em] text-white/45">Booking</p>
            <h2 className="mt-4 max-w-2xl font-display text-3xl leading-[1.1] tracking-[-0.02em] text-white sm:text-4xl lg:text-5xl">
              Udlejning til fester
            </h2>
            <p className="mt-5 max-w-xl text-sm leading-7 text-white/70">
              Alt samlet i en rolig og overskuelig løsning, så du hurtigt kan få styr på udstyr, levering og opsætning.
            </p>
            <div className="mt-8 flex items-center gap-4 text-white/70">
              <a
                href="https://facebook.com/profile.php?id=61573571575828"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white transition-colors hover:border-brand-sky hover:text-brand-sky"
                aria-label="Besøg vores Facebook-side"
              >
                <i className="fa-brands fa-facebook-f" aria-hidden="true" />
              </a>
              <div className="h-px flex-1 bg-white/10" />
            </div>
          </div>

          <div className="space-y-10">
            <div className="border-l border-white/10 pl-6">
              <p className="mt-3 text-2xl font-display text-white">Ring eller skriv</p>
              {contactInfo?.phone && (
                <a href={`tel:${contactInfo.phone.replace(/\s+/g, '')}`} className="mt-3 block text-lg font-medium text-brand-lilac transition-colors hover:text-white">
                  {contactInfo.phone}
                </a>
              )}
              {contactInfo?.email && (
                <a href={`mailto:${contactInfo.email}`} className="mt-1 block text-lg font-medium text-brand-lilac transition-colors hover:text-white">
                  {contactInfo.email}
                </a>
              )}
            </div>

            <div className="border-l border-white/10 pl-6">
              <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-white/45">Adresse</p>
              <p className="mt-3 text-2xl font-display text-white">{getVal(contactInfo?.address) || 'Lombjergevej 20, 5750 Ringe'}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 bg-black/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-5 text-xs text-white/45 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <p>&copy; {currentYear} J F D Service. Alle rettigheder forbeholdes.</p>
            <Link to="/lejebetingelser" className="hover:text-white transition-colors">Lejebetingelser</Link>
          </div>
          <p className="flex items-center gap-1">
            <span>Designet med</span>
            <i className="fa-solid fa-heart text-brand-sky" aria-hidden="true" />
            <span>af</span>
            <span className="font-semibold text-white">Auxo</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
